export const BROWSER_TIMEZONE = Intl.DateTimeFormat().resolvedOptions().timeZone

export default { BROWSER_TIMEZONE }
